/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

const Icon = ({
  path,
  size = 1,
  color = null,
  horizontal = false,
  vertical = false,
  rotate = 0,
  spin = false,
  inline = false,
  className: cls = null,
  style,
  ...props
}) => {
  const className = classNames('mdn-icon', cls, {
    'mdn-icon-inline': inline,
    'mdn-icon-spin': spin,
  });

  // Handle size: multiplier (number) or string with units
  const sizeValue = typeof size === 'number' ? `${size * 1.5}rem` : size;

  // Build transformation
  const transforms = [];
  if (horizontal) transforms.push('scaleX(-1)');
  if (vertical) transforms.push('scaleY(-1)');
  if (rotate !== 0) transforms.push(`rotate(${rotate}deg)`);

  const transform = transforms.length > 0 ? transforms.join(' ') : undefined;

  const mergedStyle = {
    width: sizeValue,
    height: sizeValue,
    fill: color || 'currentColor',
    transform,
    ...(style || {}),
  };

  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      style={mergedStyle}
      {...props}
    >
      <path d={path} />
    </svg>
  );
};

Icon.propTypes = {
  path: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  horizontal: PropTypes.bool,
  vertical: PropTypes.bool,
  rotate: PropTypes.number,
  spin: PropTypes.bool,
  inline: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Icon;
